import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private subscriptionPlan = new BehaviorSubject<any | null>(null);
  private baseUrl = environment.BACKEND_URL;

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  initiatePayment() {
     return this.http.get(`${this.baseUrl}/stripe/create-ssl-checkout`)
  }
  setSubcription(plan: any): void {
    this.subscriptionPlan.next(plan);
    this.storageService.setUserSubscription(plan);
  }

  loadSubscription(): void {
    const cachedSubscription = this.storageService.getUserSubscription();
    if (cachedSubscription) {
      // Log the cached subscription for debugging purposes
      this.subscriptionPlan.next(cachedSubscription);
    }

    this.http.get(`${this.baseUrl}/user/active-subscription`).subscribe({
      next: (response: any) => {
        console.log('subscription.service.ts [5cca2b] response: ', response);

        // FIX: Only set subscription if it's actually active
        if (response && response.is_active === true) {
          this.subscriptionPlan.next(response);
          this.storageService.setUserSubscription(response);
        } else {
          // FIX: Clear subscription if it's not active
          this.clearSubscription();
        }
      },
      error: (error) => {
        console.error('Failed to fetch subscription', error);
        this.clearSubscription();
      },
    });
  }

  refreshSubscription(): void {
    this.http.get(`${this.baseUrl}/user/active-subscription`).subscribe({
      next: (response: any) => {
        console.log('subscription.service.ts [refresh] response: ', response);

        // FIX: Only set subscription if it's actually active
        if (response && response.is_active === true) {
          this.subscriptionPlan.next(response);
          this.storageService.setUserSubscription(response);
        } else {
          this.clearSubscription();
        }
      },
      error: (error) => {
        console.error('Failed to refresh subscription', error);
        this.clearSubscription();
      },
    });
  }

  getSubscriptionObservable() {
    return this.subscriptionPlan.asObservable();
  }

  getSubscriptionValue(): any | null {
    return this.subscriptionPlan.value;
  }

  isFeatureAvailable(featureCode: string, currentCount: number): boolean {
    const plan = this.subscriptionPlan.value?.subscription_plan;
    if (!plan?.features) return false;

    const feature = plan.features.find((f: any) => f.feature?.code === featureCode);
    console.log(
      'subscription.service.ts [isFeatureAvailable] feature: ',
      feature?.feature?.limit,
      currentCount < (feature?.quantity ?? 0)
    );
    if (!feature) return false;
    return currentCount < feature?.quantity;
  }

  // FIX: Enhanced clearSubscription method
  clearSubscription(): void {
    this.storageService.deleteUserSubscription();
    this.subscriptionPlan.next(null);
    console.log('Subscription cleared from service and storage');
  }

  // FIX: Add method to check if user has active subscription
  hasActiveSubscription(): boolean {
    const subscription = this.subscriptionPlan.value;
    return subscription && subscription.is_active === true;
  }

  // FIX: Add method to get current plan name for navbar
  getCurrentPlanName(): string | null {
    const subscription = this.subscriptionPlan.value;
    if (!subscription || !subscription.is_active) return null;
    return subscription.subscription_plan?.name || null;
  }
}